<template>   
   <!--router-link :to="'/argomenti/' + argument.replace(/\s/g, '-')" class="chip chip-simple mx-1">{{argument}}</router-link-->   
   <router-link :to="link" class="chip chip-default mx-1 my-1">{{$props.tag}}</router-link>
</template>
<script>
export default {
   name: "argomento",
   props: {   
      tag: {
         type: String,
         required: true,
         description: "Name of argument"
      },
      linkHref: {
         link: String,
         description: "Link for chip"
      }      
   },
   computed:{
      link: function () {
         if(this.$props.linkHref){
            return this.$props.linkHref;
         }
         else{
            return '/cerca/' + this.$props.tag;
         }
      }
   }  
};
</script>
<style scoped>
</style>
